import React from "react";
import { useNavigate } from "react-router-dom";
import "../static/Home.css";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper">

      {/* ⭐ Background Stars */}
      <div className="stars"></div>

      {/* ================= HERO SECTION ================= */}
      <section className="hero">
        <h1>
          Transform Your Career with <span>Industry-Ready Tech Skills</span>
        </h1>

        <p>
          QAura Tech Academy provides structured, project-based training in 
          Java, Spring Boot, React, Python, and AI — designed to make you confident, 
          skilled, and employable.
        </p>

        <div className="hero-buttons">
          <button onClick={() => navigate("/courses")}>
            Explore Courses
          </button>
          <button 
            className="secondary-btn"
            onClick={() => navigate("/register")}
          >
            Start Learning Free
          </button>
        </div>
      </section>

      {/* ================= STATS SECTION ================= */}
      <section className="stats">
        <div className="stat-card">
          <h2>120+</h2>
          <p>Active Learners</p>
        </div>
        <div className="stat-card">
          <h2>25+</h2>
          <p>Real-Time Projects</p>
        </div>
        <div className="stat-card">
          <h2>10+</h2>
          <p>Expert Mentors</p>
        </div>
        <div className="stat-card">
          <h2>95%</h2>
          <p>Course Completion Rate</p>
        </div>
      </section>

      {/* ================= WHY QAURA ================= */}
      <section className="why-section">
        <h2>Why Students Choose QAura Tech Academy?</h2>

        <div className="why-grid">
          <div className="why-card">
            <h3>Structured Learning Path</h3>
            <p>
              Clear roadmap from beginner to advanced with step-by-step guidance.
            </p>
          </div>

          <div className="why-card">
            <h3>Real-Time Projects</h3>
            <p>
              Build complete applications like LMS, REST APIs, and authentication systems.
            </p>
          </div>

          <div className="why-card">
            <h3>Interview Preparation</h3>
            <p>
              Java, Spring, React, SQL & DSA preparation with mock interviews.
            </p>
          </div>

          <div className="why-card">
            <h3>Placement-Focused Training</h3>
            <p>
              Resume building, LinkedIn optimization & GitHub portfolio guidance.
            </p>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="cta">
        <h2>Your Tech Career Starts Here</h2>
        <p>
          Don’t just watch tutorials. Build projects. Gain skills. Get hired.
        </p>
        <button onClick={() => navigate("/register")}>
          Join QAura Today
        </button>
      </section>

    </div>
  );
}

export default Home;